<template>
  <div class="content">
    <h1 class="is-hidden">Glossar</h1>
    <div class="box">
      <p class="is-size-7-mobile">Hier findest du eine Sammlung verschiedener Begriff aus der Elektrotechnik. Wähle einen Buchstaben.</p>
    </div>

    <div class="buttons is-centered">
      <router-link :to="{name: 'glossary-a'}" class="button is-60px-width" @click="toggleDropdown()">A</router-link>
      <router-link :to="{name: 'glossary-b'}" class="button is-60px-width" @click="toggleDropdown()">B</router-link>
      <router-link :to="{name: 'glossary-c'}" class="button is-60px-width" @click="toggleDropdown()">C</router-link>
      <router-link :to="{name: 'glossary-d'}" class="button is-60px-width" @click="toggleDropdown()">D</router-link>
      <router-link :to="{name: 'glossary-e'}" class="button is-60px-width" @click="toggleDropdown()">E</router-link>
      <router-link :to="{name: 'glossary-f'}" class="button is-60px-width" @click="toggleDropdown()">F</router-link>
      <router-link :to="{name: 'glossary-g'}" class="button is-60px-width" @click="toggleDropdown()">G</router-link>
      <router-link :to="{name: 'glossary-h'}" class="button is-60px-width" @click="toggleDropdown()">H</router-link>
      <router-link :to="{name: 'glossary-i'}" class="button is-60px-width" @click="toggleDropdown()">I</router-link>
      <router-link :to="{name: 'glossary-j'}" class="button is-60px-width" @click="toggleDropdown()">J</router-link>
      <router-link :to="{name: 'glossary-k'}" class="button is-60px-width" @click="toggleDropdown()">K</router-link>
      <router-link :to="{name: 'glossary-l'}" class="button is-60px-width" @click="toggleDropdown()">L</router-link>
      <router-link :to="{name: 'glossary-m'}" class="button is-60px-width" @click="toggleDropdown()">M</router-link>
      <router-link :to="{name: 'glossary-n'}" class="button is-60px-width" @click="toggleDropdown()">N</router-link>
      <router-link :to="{name: 'glossary-o'}" class="button is-60px-width" @click="toggleDropdown()">O</router-link>
      <router-link :to="{name: 'glossary-p'}" class="button is-60px-width" @click="toggleDropdown()">P</router-link>
      <router-link :to="{name: 'glossary-q'}" class="button is-60px-width" @click="toggleDropdown()">Q</router-link>
      <router-link :to="{name: 'glossary-r'}" class="button is-60px-width" @click="toggleDropdown()">R</router-link>
      <router-link :to="{name: 'glossary-s'}" class="button is-60px-width" @click="toggleDropdown()">S</router-link>
      <router-link :to="{name: 'glossary-t'}" class="button is-60px-width" @click="toggleDropdown()">T</router-link>
      <router-link :to="{name: 'glossary-u'}" class="button is-60px-width" @click="toggleDropdown()">U</router-link>
      <router-link :to="{name: 'glossary-v'}" class="button is-60px-width" @click="toggleDropdown()">V</router-link>
      <router-link :to="{name: 'glossary-w'}" class="button is-60px-width" @click="toggleDropdown()">W</router-link>
      <router-link :to="{name: 'glossary-x'}" class="button is-60px-width" @click="toggleDropdown()">X</router-link>
      <router-link :to="{name: 'glossary-y'}" class="button is-60px-width" @click="toggleDropdown()">Y</router-link>
      <router-link :to="{name: 'glossary-z'}" class="button is-60px-width" @click="toggleDropdown()">Z</router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ee-glossary',
  metaInfo: {
    title: 'Elektrotechnik Glossar | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Sammlung von Begriffen aus der Elektrotechnik.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Glossar', route: 'start' })
  },
  methods: {
    toggleDropdown () {
      if (this.dropdown_active) {
        this.dropdown_active = false
      } else {
        this.dropdown_active = true
      }
    }
  },
  data () {
    return {
      dropdown_active: false
    }
  }
}
</script>
